import React, { useEffect, useState } from "react";
import { coachGetAthleteProgress } from "../../lib/api";
import { ProgressWidgets } from "../ProgressWidgets";

/** The athlete's Progress tab (calendar · volume chart · activities), as the coach sees it. */
export default function CoachAthleteProgress({ athleteId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!athleteId) return;
    coachGetAthleteProgress(athleteId).then(setData).catch(() => setErr("Couldn't load progress."));
  }, [athleteId]);
  if (err) return <p className="text-sm text-[var(--tir-burgundy)]" data-testid="coach-progress-error">{err}</p>;
  if (!data) return <p className="text-sm text-[var(--tir-muted)]" data-testid="coach-progress-loading">Loading progress…</p>;
  return (
    <div className="space-y-5" data-testid="coach-athlete-progress">
      <ProgressWidgets data={data} today={data.today} />
    </div>
  );
}
